module.exports = __webpack_public_path__ + "static/media/HsIsxMZiWKrNUavQUXqx.70af7a35.svg";